import React from 'react';
import { Form, Input, Select, DatePicker, Modal, Button, Row, Col } from 'antd';

import moment from 'components/momentWithZone';
import globalFormItemLayout from 'components/Portal/formItemLayout';
import DictionarySelect from 'components/DictionarySelect';
import AddressInput from 'components/AddressInput';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';

const genderOptions = [
	//['Agender', 'Androgynous', 'Bigender', 'Cisgender Female', 'Cisgender Male', 'Female',
	// 'Female to Male', 'Gender Fluid', 'Gender Nonconforming', 'Gender Questioning',
	// 'Gender Variant', 'Genderqueer', 'Intersex', 'Male', 'Male to Female', 'Neither',
	// 'Non-binary', 'Pangender', 'Trans person', 'Transgender', 'Other']
	{ value: 'F', label: 'Female' },
	{ value: 'M', label: 'Male' },
	// {value: 'N', label: 'Unspecified'}
];
//Voyage Number Not Required

class BasicInformation extends React.Component {
	state = {
		showAwardModal: false
	}

	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.updateFolio(this.props.form, 'Folio')
			.catch(console.error)
			.then(() => { this.props.isSubmitted(); });
	}

	handleCancel = () => {
		this.setState({ showAwardModal: false })
	}
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'personal/basic');
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(this.props, 'personal/basic');
			if (redirect) return redirect;
		}

		const { getFieldDecorator } = this.props.form;
		const formItemLayout = Object.assign({ className: 'inResco' }, globalFormItemLayout);
		const {
			Forename, Midname, Surname, BirthDate, Alias, Gender, Marital, Nationality, Email1,
			Phone1, Phone3, Street, City, Province, PostalCode, Country
		} = this.props.folio;
		return (
			<Form onSubmit={this.handleSubmit}>
				<legend>Profile</legend>
				<Form.Item label="First Name" {...formItemLayout}>
					{getFieldDecorator('Forename', {
						initialValue: Forename,
						rules: [{ required: true, message: 'First Name is required' }]
					})(
						<Input disabled={disabled} />
					)}
				</Form.Item>
				<Form.Item label="Middle Name" {...formItemLayout}>
					{getFieldDecorator('Midname', {
						initialValue: Midname
					})(
						<Input disabled={disabled} />
					)}
				</Form.Item>
				<Form.Item label="Last Name" {...formItemLayout}>
					{getFieldDecorator('Surname', {
						initialValue: Surname,
						rules: [{ required: true, message: 'Last Name is required' }]
					})(
						<Input disabled={disabled} />
					)}
				</Form.Item>
				<Form.Item label="Date of Birth" {...formItemLayout}>
					{getFieldDecorator('BirthDate', {
						initialValue: BirthDate && moment.utc(BirthDate),
						rules: [{ required: true, message: 'Birth date is required' }]
					})(
						<DatePicker disabled={disabled} />
					)}
				</Form.Item>
				<Form.Item label="Preferred First Name" {...formItemLayout}>
					{getFieldDecorator('Alias', {
						initialValue: Alias
					})(
						<Input />
					)}
				</Form.Item>
				<Form.Item label="Sex" {...formItemLayout}>
					{getFieldDecorator('Gender', {
						initialValue: Gender,
						rules: [{ required: true, message: 'Please specify your sex' }]
					})(
						<Select disabled={disabled}>
							{genderOptions.map(gender => {
								return <Select.Option key={gender.value}>{gender.label}</Select.Option>
							})}
						</Select>
					)}
				</Form.Item>
				<DictionarySelect
					disabled={disabled}
					label="Marital Status"
					code="MAR"
					field="Marital"
					initialValue={Marital}
					formItemLayout={formItemLayout}
					getFieldDecorator={getFieldDecorator} />
				<DictionarySelect
					disabled={disabled}
					label="Nationality"
					code="CNT"
					field="Nationality"
					initialValue={Nationality}
					formItemLayout={formItemLayout}
					getFieldDecorator={getFieldDecorator} />
					<Form.Item label="SAS ID" {...formItemLayout}>
					{getFieldDecorator('SASID', {
						initialValue: this.props.folio.RepeaterNo,
					})(
						<Input disabled={disabled}  />
					)}
				</Form.Item>
				<legend>Contact</legend>
				<Form.Item label="Email Address" {...formItemLayout}>
					{getFieldDecorator('Email1', {
						initialValue: Email1,
						validateTrigger: 'onBlur',
						rules: [
							{ type: 'email', message: 'Not a valid email address' },
							{ required: true, message: 'Email Address is required' }
						]
					})(
						<Input type="email" disabled={disabled} />
					)}
				</Form.Item>
				<Form.Item label="Cell Phone" {...formItemLayout}>
					{getFieldDecorator('Phone1', {
						initialValue: Phone1,
						rules: [
							{ pattern: /^[\+(0-9)-\s\.]{6,20}$/im, message: 'Invalid phone number' },
							{ required: true, message: 'Phone number is required' }
						]
					})(
						<Input disabled={disabled} />
					)}
				</Form.Item>
				<Modal
					onCancel={this.handleCancel}
					visible={this.state.showAwardModal}
					footer={null}>
					<legend>Voyage Phone Number</legend>
					<p>Are you using WhatsApp, Viber or some other phone number during your voyage? If no, please enter the number of the cell phone you will be taking with you on the voyage.   </p>
				</Modal>
				<Form.Item label={<span>Voyage Phone Number &nbsp; 
				<Button icon="question-circle"
				onClick={() => this.setState({ showAwardModal: true })} /> </span>
				} {...formItemLayout}>
					{getFieldDecorator('Phone3', {
						initialValue: Phone3,
						rules: [
							{ pattern: /^[\+(0-9)-\s\.]{6,20}$/im, message: 'Invalid phone number' }
						]
					})(
						<Input />
					)}
				</Form.Item>
				<legend>Street Address <span style={{ color: 'red' }}>*</span></legend>
				<AddressInput
					disabled={disabled}
					form={this.props.form}
					address={{
						Street: Street,
						City: City,
						Province: Province,
						PostalCode: PostalCode,
						Country: Country
					}}
					required={true}
					getFieldDecorator={getFieldDecorator} />
				{<SaveButton
					disabled={!this.props.form.isFieldsTouched()}
					loading={this.props.getStatus().submitting} />}
			</Form>
		);
	}
}

export default withSpin(Form.create()(BasicInformation));



// WEBPACK FOOTER //
// ./portal-components/Portal/Personal/BasicInformation.jsx